export default __webpack_public_path__ + "static/media/PRINT-NEW.05087a45.webp";